import { createBaseResourceActions } from '../create-base-resource-actions';
import { OrderUpdateRequestResourceTypeMappings } from '@aa/nest/resource';

const domainSlug = '[ORDER UPDATE REQUEST]';
export const orderUpdateRequestActions =
  createBaseResourceActions<OrderUpdateRequestResourceTypeMappings>(domainSlug);
